import { Component, ElementRef, ViewChild } from '@angular/core';
import { BreadcrumbServiceService } from '../../../../shared/services/breadcrumb-service.service';
import { CustuomtoastserviceService } from '../../../../shared/services/custuomtoastservice.service';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';
import { BaseUserModel, UserPermissionsModel } from 'src/app/Models/userModel';
import { UserService } from 'src/app/shared/services/user-service';
import { ProductMarketPlaceLisitngApiServiceService } from 'src/app/features/MarketPlace/services/productMarketplaceLisitng-api-service';
import {
  PaginatedProductMarketPlaceLisitngsResponse,
  ProductMarketplaceListingStatus,
} from 'src/app/Models/productMarketPlaceLIstingModel';
import { PostingProfilesService } from 'src/app/features/posting-profile/services/postingProfiles-api-service';
import { PostingProfileResponse } from 'src/app/features/posting-profile/models/strategiesModel';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import {
  PageSizes,
  PaginationUtilsService,
} from 'src/app/shared/services/pagination-utils.service';
import { MarketplaceIntegrations } from 'src/app/Models/marketplaceAccountModel';
import { NamedResponse } from 'src/app/shared/models/shared.model';

@Component({
  selector: 'app-manage-listings',
  standalone: false,
  templateUrl: './manage-listings.component.html',
  styleUrls: ['./manage-listings.component.css'],
})
export class ManageListingsComponent {
  userDetails: BaseUserModel = new BaseUserModel();
  productMarketplaceList: PaginatedProductMarketPlaceLisitngsResponse =
    new PaginatedProductMarketPlaceLisitngsResponse();
  postingProfileList: PostingProfileResponse[] = [];
  listingStatusList: string[] = [];
  isEditMode: boolean = false;
  nameAttempted: boolean = false;
  attemptedName: boolean = false;
  showValidation: boolean = false;
  @ViewChild('closeModal') closeModal!: ElementRef;
  userPermissions: UserPermissionsModel[] = [];
  marketplaceList: NamedResponse[] = Object.keys(MarketplaceIntegrations)
    .filter((key) => !isNaN(Number(key)))
    .map((key) => {
      return {
        id: Number(key),
        name: MarketplaceIntegrations[Number(key)],
      } as NamedResponse;
    });
  searchSubject = new Subject<string>();
  pageSizes = PageSizes;
  currentPage: number = 1;
  itemsPerPage: number = this.pageSizes[0];
  totalPages: number = 0;
  totalRecords: number = 0;
  pagesToShow: number[] = [];

  marketplaceEnumList:NamedResponse[]=[];
  listingStatusEnumList:NamedResponse[]=[]
  postingTypeEnumList:NamedResponse[]=[]
  sortField: string = 'CreatedAt';
  sortDirection: 'asc' | 'desc' = 'desc';
  statusFilter:number = 0;
  typeFilter:number = 0;
  marketplaceFilter:number = 0;
  postingProfileFilter:number=0;
  constructor(
    private toaster: CustuomtoastserviceService,
    private postingProfileService: PostingProfilesService,
    private breadcrumbService: BreadcrumbServiceService,
    private productMarketPlaceListingService: ProductMarketPlaceLisitngApiServiceService,
    private paginationUtils: PaginationUtilsService,
    private errorService: ErrorHandlerService,
    private userService: UserService
  ) { }
  async ngOnInit() {
    this.userPermissions = await this.userService.getUserRolesandPerm();
    const user = this.userService.getUserFromLocalStorage(); // Assuming companyId is a property of user
    if (user) {
      this.userDetails = user;
    } else {
      // Handle the case where user is null
      this.toaster.error('User details not found');
    }
    this.breadcrumbService.setBreadcrumbs([
      { label: 'Marketplace', url: 'demo' },
      { label: 'Listings', url: 'listings' },
    ]);

    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((searchTerm: string) => {
        this.getMarketPlaceListings(searchTerm);
      });
    await this.loadLookupsAsync();
    this.getPostingProfiles();
    this.getListingStatuses();
    this.getMarketPlaceListings();
  }

  onSearchKeyUp(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchSubject.next(value);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getMarketPlaceListings();
  }

  onItemsPerPageChange(size: number) {
    this.itemsPerPage = size;
    this.currentPage = 1;
    this.getMarketPlaceListings();
  }
  async loadLookupsAsync(): Promise<void> {
    try {
      const storageKey = 'lookups';
      const storedData = await localStorage.getItem(storageKey);

      if (!storedData) return;

      const dataArray = await JSON.parse(storedData);
      if (!Array.isArray(dataArray)) return;

      this.marketplaceEnumList = this.getLookupItems(
        dataArray,
        'Marketplace'
      );
      this.listingStatusEnumList = this.getLookupItems(
        dataArray,
        'ProductListingStatus'
      );
      this.postingTypeEnumList = this.getLookupItems(dataArray, 'PostingProfileRuleType');
    } catch (error) {
      this.toaster.error('Failed to load lookups');
    }
  }
  private getLookupItems(data: any[], key: string): any[] {
    return data.find((item) => item.name === key)?.items || [];
  }

  getMarketPlaceListings(searchTerm?: string) {
    if (searchTerm) {
      this.currentPage = 1;
    }
    const sortCriteria = `${this.sortField} ${this.sortDirection}`;

    this.productMarketPlaceListingService
      .getProductMarketPlaceListings(
        this.userDetails.companyId,
        this.statusFilter,
        this.typeFilter,
        this.marketplaceFilter,
        this.postingProfileFilter,
        this.currentPage,
        this.itemsPerPage,
        searchTerm,
        sortCriteria
      )
      .subscribe(
        (result) => {
          if (result) {
            this.productMarketplaceList = result;
            this.totalRecords = result.totalCount;
            this.totalPages = Math.ceil(
              this.totalRecords / this.itemsPerPage
            );
            this.pagesToShow = this.paginationUtils.getDisplayedPages(
              this.currentPage,
              this.totalRecords,
              this.itemsPerPage
            );
          }
        },
        (error) => {
          this.errorService.handleError(error);
        }
      );

  }

  getListingStatuses() {
    this.listingStatusList = Object.keys(
      ProductMarketplaceListingStatus
    ).filter((key) => isNaN(Number(key))); // This filters out the numeric reverse mappings
  }
  getPostingProfiles() {
    this.postingProfileService
      .getPostingProfiles(this.userDetails.companyId)
      .subscribe(
        (response) => {
          this.postingProfileList = response;
        },
        (error) => {
          this.errorService.handleError(error);
        }
      );
  }

  resetFilter() {
    this.statusFilter = 0;
    this.marketplaceFilter =0;
    this.typeFilter =0;
    this.getMarketPlaceListings();
  }
  // Method to check if a permission exists
  hasPermission(permissionName: string): boolean {
    return this.userPermissions.some(
      (permission) => permission.name === permissionName
    );
  }
}
